import {
  FIGMA_TOP_PADDING_FULL_WIDTH,
  FIGMA_TOP_PADDING_MOBILE,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.figma';
import {
  getMultiSectionFigmaLayout,
  pushGapToColumn,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/sections.common';

import type { ViewData } from '../common/multisection.data';

export function addPageTopPadding(viewData: ViewData): ViewData {
  const { layoutTable } = viewData;
  const height =
    getMultiSectionFigmaLayout(viewData) === 'full'
      ? FIGMA_TOP_PADDING_FULL_WIDTH
      : FIGMA_TOP_PADDING_MOBILE;

  layoutTable?.forEach(pushGapToColumn(height, viewData));
  return viewData;
}

// allows the last component to scroll above minimap
export function addPageBottomPadding(viewData: ViewData): ViewData {
  const { layoutTable } = viewData;
  layoutTable?.forEach(pushGapToColumn(250, viewData));

  return viewData;
}
